"use client";

import { useEffect, useRef } from "react";
import Image from "next/image";

interface ProductInfoSwiperProps {
  product: {
    id: string;
    title: string;
    relateproimage?: string[];
  };
}

const ProductInfoSwiper = ({ product }: ProductInfoSwiperProps) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    console.log(`Images initialized for product: ${product.title}`);
    
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer || !product.relateproimage || product.relateproimage.length < 2) return;

    const scrollWidth = scrollContainer.scrollWidth;
    const clientWidth = scrollContainer.clientWidth;
    let scrollPosition = 0;

    const scroll = () => {
      scrollPosition += 1; // Adjust speed by changing this value
      if (scrollPosition >= scrollWidth - clientWidth) {
        scrollPosition = 0; // Reset to start for seamless loop
        scrollContainer.scrollTo({ left: 0, behavior: "auto" }); // Instant jump to start
      } else {
        scrollContainer.scrollTo({ left: scrollPosition, behavior: "smooth" });
      }
    };

    const interval = setInterval(scroll, 16); // ~60fps for smooth animation (1000ms / 60)
    return () => clearInterval(interval);
  }, [product.title, product.relateproimage]);

  // Check if relateproimage exists and is an array
  if (!product.relateproimage || !Array.isArray(product.relateproimage) || product.relateproimage.length === 0) {
    return (
      <div className="!mb-8">
        <h1 className="!text-[#00819E] !text-center !font-['DM_Sans'] !text-[24px] !!font-medium !mb-4">
          {product.title}
        </h1>
        <p className="!text-center !text-gray-500">No related images available.</p>
      </div>
    );
  }

  return (
    <div className="!mb-8">
      {/* <h1 className="!text-[#00819E] !text-center !font-['DM_Sans'] !text-[24px] !!font-medium !mb-4">
        {product.title}
      </h1> */}
      <div
        ref={scrollContainerRef}
        className="!flex !overflow-x-auto !scroll-smooth !snap-x !snap-mandatory !gap-4 !px-4
          md:!justify-center md:!flex-wrap lg:!flex-wrap lg:!justify-center"
      >
        {product.relateproimage.map((image, index) => (
          <div
            key={`${product.id}-image-${index}`}
            className="!snap-center !flex-shrink-0 !w-[300px] !rounded-[12px] !bg-[#CCF2FA] 
              !shadow-[0_0_18.487px_0_rgba(0,0,0,0.10)] !p-[16px] 
              sm:!w-[300px] md:!w-[calc(33.33%-16px)] lg:!w-[calc(25%-16px)]"
          >
            <Image
              src={image}
              alt={`${product.title} related image ${index + 1}`}
              width={300}
              height={200}
              priority={index === 0}
              className="!w-full !h-auto !object-cover !rounded-[8px]"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductInfoSwiper;